import React from "react";

import useScroll from "../../../hooks/useScroll";
import { HeaderWrapper, Logo } from "./Header.style";

const brazeLogo =
  "https://s3.us-east-1.amazonaws.com/appboy-images.com/dashboard-assets/dashboard/free-trial-reg/Braze%20logo.svg";

export const Header = ({ isShowingSalesBanner }: { isShowingSalesBanner: boolean }) => {
  const isScrolled = useScroll();

  return (
    <HeaderWrapper isScrolled={isScrolled} isShowingSalesBanner={isShowingSalesBanner}>
      <Logo src={brazeLogo} alt="Logo" />
    </HeaderWrapper>
  );
};

export default Header;
